import * as React from 'react';

import useAuthStore from 'store/authStore/useAuthStore';

import { PERCENT_OPTIONS } from './PercentButtons.constants';
import { Buttons, Container, PercentButton } from './PercentButtons.styled';

interface PercentButtonsProps {
    setPercent: (percent: number) => void;
    compact?: boolean;
    pending?: boolean;
}

const PercentButtons = ({ setPercent, compact, pending = false }: PercentButtonsProps) => {
    const { account } = useAuthStore();

    if (!account && !pending) {
        return null;
    }
    return (
        <Container>
            <Buttons $compact={compact}>
                {PERCENT_OPTIONS.map(percent => (
                    <PercentButton
                        key={percent}
                        type="button"
                        $compact={compact}
                        disabled={pending}
                        onClick={() => !pending && setPercent(percent)}
                    >
                        {percent}%
                    </PercentButton>
                ))}
            </Buttons>
        </Container>
    );
};

export default PercentButtons;
